export const CONFIG = {
  apiUrl: process.env.REACT_APP_API_URL,
  cardPointUrl: process.env.REACT_APP_CARDPOINTE_URL,
  cardPointIframeUrl: process.env.REACT_APP_CARDPOINTE_IFRAME_URL,
  reCaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY,
};
